export default "__VITE_ASSET__2ff08f00__"